import { ChatDocument } from '../../../../domain/documents/models/ChatDocument';
import { ProGPTChatDocumentDto } from '../dtos/responses/ProGPTDocumentDto';

const toTimestamp = (value: string | number): number => {
    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const mapProGPTChatDocumentDtoToModel = (dto: ProGPTChatDocumentDto): ChatDocument => ({
    id: dto.id,
    chatId: dto.chatId,
    name: dto.name,
    createdOn: toTimestamp(dto.createdOn),
    tokens: dto.tokens,
    size: dto.size,
    userId: dto.userId,
});

export const mapProGPTDocumentsResponseToModels = (
    response: ProGPTChatDocumentDto | ProGPTChatDocumentDto[],
): ChatDocument[] => {
    const documents = Array.isArray(response) ? response : [response];
    return documents.map(mapProGPTChatDocumentDtoToModel);
};
